/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import  { FC, useState, useRef } from "react";
import { useFormik } from "formik";
import clsx from "clsx";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import { useParams } from "react-router-dom";
import {
  checkDuplicateCoupon,
  updateCoupon,
} from "../core/_requests";
import { useNavigate } from "react-router-dom";
import { UUID } from "crypto";
import ListCoupon from "./ListCoupon";

import { couponSchema } from "../core/Schema";

interface Cuisine {
  uuid: UUID;
  name: string;
}

interface Category {
  uuid: UUID;
  name: string;
}

interface CouponAdd {
  couponValueType?: number;
  chefId: string | undefined;
  name: string;
  amount: string;
  limit: string;
  minimumOrderValue: string;
  usagePerUser: string;
  categoryId: string;
  cuisineId: string;
  startDate: string;
  endDate: string;
  couponType: string;
  createdBy: any;
  updatedBy: any;
}

type Props = {
  initialValues: CouponAdd;
};

const EditCoupon: FC<Props> = ({ initialValues }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [data, setData] = useState<CouponAdd>(initialValues);
  const [loading, setLoading] = useState(false);
  const [cuisine, setCuisine] = useState<Cuisine[]>([]);
  const [category, setCategory] = useState<Category[]>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [Duplicate, setDuplicate] = useState("");
  const [currentDate] = useState(new Date());
  const [placeholderText, setPlaceholderText] = useState("Enter coupon value");
  const { id } = useParams();
  const inputs = useRef<Array<HTMLInputElement | HTMLSelectElement | null>>([]);
  const chefId = currentUser?.uuid;

  const clickCancel = () => {
    navigate("/coupon");
  };

  const formik = useFormik<CouponAdd>({
    initialValues,
    validationSchema: couponSchema,
    onSubmit: async (values, actions) => {
      values.chefId = chefId;
      values.updatedBy = currentUser?.chefId;
      const updatedData = Object.assign(data, values);
      setLoading(true);
      updateCoupon(id, updatedData).then((res) => {
        if (res?.status === true) {
          navigate("/coupon/editsuccess", { replace: true });
          setLoading(false);
        } else {
          setLoading(false);
          setErrorMessage(res?.message);
        }
      });
    },
  });



  const nextDate = new Date();
  nextDate.setDate(currentDate.getDate());

      return (
    <>
      <section className="container-fluid addContainerFluid">
        <ListCoupon />
        <div className="overlay"></div>
        <div className="drawer small">
          <div className="title row">
            <h3 className="col-10 mb-0">Edit Coupon</h3>
            <div className="col-2 text-end mb-2">
              <button
                className="btn p-0 close d-inline-flex"
                onClick={clickCancel}
              >
                <i className="material-symbols-outlined">close</i>
              </button>
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            noValidate
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <div className="col-12 mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Coupon Code
              </label>
              <input
                type="text"
                ref={(el) => {
                  inputs.current[1] = el;
                }}
                
                className={clsx(
                  "form-control",
                  {
                    "is-invalid": formik.touched.name && formik.errors.name,
                  },
                  {
                    "is-valid": formik.touched.name && !formik.errors.name,
                  }
                )}
                placeholder="Give a code to coupon"
                {...formik.getFieldProps(`name`)}
                onChange={(e) => {
                  formik.handleChange(e);
                  // Perform duplicate check here
                  checkDuplicateCoupon(e.target.value).then((response) => {
                    if (response?.isDuplicate === true) {
                      setDuplicate("Coupon Name already exists");
                    } else {
                      setDuplicate("");
                    }
                  });
                }}
              />
              {formik.touched.name && formik.errors.name && (
                <div className="fv-help-block text-danger">
                  {formik.errors.name}
                </div>
              )}
              <span style={{ color: "red" }}>{Duplicate ? Duplicate : ""}</span>
            </div>
            {/**Begin:  coupon value */}
            <div className="row mb-12  mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Coupon Value
              </label>
              <div className="col-lg-6">
                <select
                  className="form-select form-select-solid form-select-lg"
                  {...formik.getFieldProps("couponValueType")}
                  ref={(el) => {
                    inputs.current[2] = el;
                  }}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    formik.handleChange(e);
                    if (selectedValue === "1") {
                      setPlaceholderText("Enter Percentage (%)");
                    } else if (selectedValue === "2") {
                      setPlaceholderText("Enter Amount ($)");
                    } else {
                      setPlaceholderText("Enter coupon value");
                    }
                  }}
                >
                  <option value="">Select Type...</option>
                  <option value={1}>Percentage</option>
                  <option value={2}>Amount ($)</option>
                </select>
              </div>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="capitalize-text form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                  placeholder={placeholderText}
                  ref={(el) => {
                    inputs.current[3] = el;
                  }}
                  
                  {...formik.getFieldProps("amount")}
                />
                {formik.touched.amount && formik.errors.amount && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block text-danger">
                      {formik.errors.amount}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/**End:  coupon value */}
            <div className="row  mb-3 mt-3 col-12">
              <label htmlFor="" className="form-label">
                Validity Perioder
              </label>
              <div className="col-lg-6 ">
                <input
                  type="datetime-local"
                  className="capitalize-text form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                  placeholder="Enter coupon start date"
                  ref={(el) => {
                    inputs.current[4] = el;
                  }}
                  min={nextDate.toISOString().slice(0, 16)}
                  {...formik.getFieldProps("startDate")}
                />
                {formik.touched.startDate && formik.errors.startDate && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block text-danger">
                      {formik.errors.startDate}
                    </div>
                  </div>
                )}
              </div>
              <div className="col-lg-6">
                <input
                  type="datetime-local"
                  className="capitalize-text form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                  placeholder="Enter coupon validity end date"
                  min={nextDate.toISOString().slice(0, 16)}
                  ref={(el) => {
                    inputs.current[4] = el;
                  }}
                  {...formik.getFieldProps("endDate")}
                />
                {formik.touched.endDate && formik.errors.endDate && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block text-danger">
                      {formik.errors.endDate}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Coupon Limit
              </label>
              <input
                type="text"
                ref={(el) => {
                  inputs.current[6] = el;
                }}
                className={clsx(
                  "form-control",
                  {
                    "is-invalid": formik.touched.limit && formik.errors.limit,
                  },
                  {
                    "is-valid": formik.touched.limit && !formik.errors.limit,
                  }
                )}
                placeholder="Give a limit to coupon"
                {...formik.getFieldProps(`limit`)}
              />
              {formik.touched.limit && formik.errors.limit && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block text-danger">
                    {formik.errors.limit}
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Minimum Order Value
              </label>
              <input
                type="text"
                ref={(el) => {
                  inputs.current[7] = el;
                }}
                className={clsx(
                  "form-control",
                  {
                    "is-invalid":
                      formik.touched.minimumOrderValue &&
                      formik.errors.minimumOrderValue,
                  },
                  {
                    "is-valid":
                      formik.touched.minimumOrderValue &&
                      !formik.errors.minimumOrderValue,
                  }
                )}
                placeholder="Give a  minimum order value"
                {...formik.getFieldProps(`minimumOrderValue`)}
              />
              {formik.touched.minimumOrderValue &&
                formik.errors.minimumOrderValue && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block text-danger">
                      {formik.errors.minimumOrderValue}
                    </div>
                  </div>
                )}
            </div>
            <div className="col-12 mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Usage Per User
              </label>
              <input
                type="text"
                ref={(el) => {
                  inputs.current[8] = el;
                }}
                className={clsx(
                  "form-control",
                  {
                    "is-invalid":
                      formik.touched.usagePerUser && formik.errors.usagePerUser,
                  },
                  {
                    "is-valid":
                      formik.touched.usagePerUser &&
                      !formik.errors.usagePerUser,
                  }
                )}
                placeholder="Give a  usage per user "
                {...formik.getFieldProps(`usagePerUser`)}
              />
              {formik.touched.usagePerUser && formik.errors.usagePerUser && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block text-danger">
                    {formik.errors.usagePerUser}
                  </div>
                </div>
              )}
            </div>

            <div className="col-12 mt-3">
              <div className="row">
                <div className="col-4"></div>
                <div className="col-8 text-end">
                  <button
                    className="btn btn-cancel rounded-5"
                    onClick={clickCancel}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={formik.isSubmitting || !formik.isValid}
                    className="btn btn-outline-primary rounded-5 me-2"
                  >
                    {!loading && (
                      <span className="indicator-label">Update</span>
                    )}
                    {loading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default EditCoupon;
